<template>
  <div class="container-fluid">
    <div v-for="(groups, groupname, index) in posters">
      <div class="" v-on:click="setOpenCollapse('group' + index)">
        <button class="btn btn-link btn-sm collapsed font-weight-bold" type="button" data-toggle="collapse"
                :data-target="'#group'+index"
                aria-expanded="false" :aria-controls="'group' + index">
          <span class="when-opened"> <icon :icon="['fad', 'chevron-down']"/> </span>
          <span class="when-closed"> <icon :icon="['fad', 'chevron-right']"/> </span>
          {{groupname}}
        </button>
      </div>
      <div class="collapse" :id="'group' + index">
        <div class="row ml-0 mr-0 poster mt-2 pb-2 border-bottom alert-primary" v-for="(poster) in groups">
          <div v-bind:id="'poster' + poster.abstract_id" class="col col-4 d-flex my-auto pb-2 pt-2">
            <router-link :to="'/viewer/' + poster.abstract_id">
              <img :src="getImgUrl(poster.content.poster)" v-bind:alt="poster.title"
                   class="img-fluid align-middle">
            </router-link>
          </div>
          <div class="col col-8 poster-text d-flex flex-column  pb-2 pt-2">
            <div>{{_.groupCapital}}: {{poster.grouped}}</div>
            <div class="align-middle mt-2 font-weight-bold">{{poster.presentation_code}}: {{poster.title}}</div>
            <div class="align-middle smaller mt-2" v-html="poster.authorline"></div>
            <div class="align-middle smaller mt-2" v-html="poster.instituteline"></div>
            <div class="mt-auto">
              <UserShare :poster="poster.abstract_id" :title="poster.title" v-if="shareShow == poster.abstract_id"
                         class="mb-1"/>
              <router-link class="btn btn-primary btn-sm" :to="'/viewer/' + poster.abstract_id">
                <icon :icon="['fad', 'eye']"/>
                View
              </router-link>
              <router-link class="btn btn-primary btn-sm ml-2" :to="'/viewer/' + poster.abstract_id"
                           v-if="poster.content.audio != null">
                <icon :icon="['fad', 'volume']"/>
                Audio
              </router-link>
              <router-link class="btn btn-primary btn-sm ml-2" :to="'/viewer/video/' + poster.abstract_id"
                           v-if="poster.content.video != null">
                <icon :icon="['fad', 'video']"/>
                Video
              </router-link>
              <!--button class="btn btn-primary btn-sm ml-2" v-on:click="toggleShare(poster.abstract_id);">
                <icon :icon="['fad', 'share']"/>
                Share
              </button-->
              <router-link class="btn btn-primary btn-sm ml-2" :to="'/mail/' + poster.abstract_id">
                <icon :icon="['fad', 'envelope']"/>
                Contact
              </router-link>
              <div class="float-right font-weight-bold">
                Rating: {{ratings[poster.id].rating}} ({{ratings[poster.id].count}} votes)
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    const VueScrollTo = require('vue-scrollto');
    import {mapState} from 'vuex'
    import Rating from "../Rating";
    import UserShare from "../UserShare";

    export default {
        data() {
            return {
                shareShow: null,
                alphaIndex: {}
            }
        },
        computed: {
            ...mapState(
                ['openCollapse', 'ratings']
            ),
        },
        props: ['posters'],
        name: "groupedCompact",
        components: {UserShare, Rating},
        methods: {
            getImgUrl(src) {
              return process.env.VUE_APP_PATH_FILESERVERURL + src + '/resize/' + process.env.VUE_APP_THUMBNAIL_WIDTH + '/' + process.env.VUE_APP_THUMBNAIL_HEIGHT;
              // return process.env.VUE_APP_PATH_S3URL + src + '-' + process.env.VUE_APP_THUMBNAIL_WIDTH + '-' + process.env.VUE_APP_THUMBNAIL_HEIGHT + '-1-undefined-image';
            },
            toggleShare: function (poster) {
                if (this.shareShow != poster) {
                    this.shareShow = poster;
                } else {
                    this.shareShow = null;
                }
            },
            setOpenCollapse: function (collapse) {
                this.$store.state.openCollapse = collapse;
            },
            scrollTo: function () {
                let scrollspeed = 500;
                if(this.$browserDetect.meta.name === 'Chrome') {
                    scrollspeed = 1500;
                }
                VueScrollTo.scrollTo('#poster' + this.$route.params.poster, scrollspeed, {easing: 'ease-in'});
            },
            makeIndex(name, position) {
                if (!name.charAt(0) in this.alphaIndex) {
                }
            }
        },
        created() {
            if (!this.$store.state.ratings.length) {
                this.$store.dispatch('GET_ALL_RATINGS');
            }
        },
        mounted() {
            if (this.$store.state.openCollapse.length > 0) {
                $('#' + this.$store.state.openCollapse).collapse('show');
            }
            if (this.$route.params.poster > 0) {
                this.scrollTo();
            }
            this.$ga.event(process.env.VUE_APP_GOOGLE_ANALYTICS_NAME, 'view/' + this.$store.state.mode.displayType, 'grouped:' + this.$store.state.mode.grouped.status);
        }
    }
</script>

<style scoped>
  .poster {
    /*border-bottom: solid 2px #7e7e7e;*/
  }

  .poster-text {
  }

  .collapsed > .when-opened,
  :not(.collapsed) > .when-closed {
    display: none;
  }
</style>
